import { Box, Theme, createStyles } from "@mui/material";
import { Button, Container, Typography } from "@mui/material";
import { FC, useEffect } from "react";

import { Link } from "react-router-dom";
import { makeStyles } from "@mui/material/styles";

const imagePath =
	"https://taxslips.blob.core.windows.net/taxslips-public-images-container/empty_employee_list.png";
export interface INoFoundPage {}
export const NoFoundPage: FC<INoFoundPage> = ({}) => {
	return (
		<Box
			sx={{
				// textAlign: 'center',
				// marginTop: '100px',
				// margin:0,
				background: "#ffffff",
				// margin: theme.spacing(2),
				textAlign: "center",
				height: "100vh",
				paddingTop: "1rem",
			}}
		>
			<img src={imagePath} alt="Not found" />
			<Box
				sx={{
					textAlign: "center",
				}}
			>
				<Typography
					variant="h2"
					sx={{
						fontSize: "3rem",
						paddingBottom: 2,
					}}
				>
					Unauthorized Access
				</Typography>
				<Typography
					variant="body1"
					sx={{
						fontSize: "1.2rem",
						paddingBottom: 4,
					}}
				>
					You are not authorized to access this page.
				</Typography>
				<Button
					component={Link}
					to="/"
					variant="contained"
					color="primary"
					className="no-underline"
				>
					Go back to home
				</Button>
			</Box>
		</Box>
	);
};
